import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import WhyMarImag1 from "../../assets/why-mar-img1.jpg";
import WhyMarImag2 from "../../assets/why-mar-img2.jpg";
import WhyMarImag3 from "../../assets/why-mar-img3.jpg";
import WhyMarImag4 from "../../assets/why-mar-img4.jpg";
import WhyMarImag5 from "../../assets/why-mar-img5.jpg";
import * as apiUrl from "../../apiUrl";

function WhyMarquisDescription({ data }) {
  const cards = data.cards ? JSON.parse(data.cards) : [];

  return (
    <section className="collection-sold-properties-sec why-mar-desc-sec">
      <Container fluid>
        <div className="flex-center text-center mb-5 row">
          <div className="col-md-8">
            <div className="heading-div">
              <h2 className="common-head darkGrey" data-aos="fade-up">
                {data.section_title}
              </h2>
              <p className="common-para" data-aos="fade-up">
                {data.section_description}
              </p>
            </div>
          </div>
        </div>
        <div className="collection-sold-properties-div row">
          {cards.map((card, index) => (
            <div
              key={index}
              className="sold-property-card col-md-6"
              data-aos={index % 2 === 0 ? "fade-right" : "fade-left"}
            >
              <img
                src={apiUrl.apiUrl + `/` + card.image}
                className="img-fluid"
                alt="Marquis Real Estate Developer in Dubai"
              />

              <div className="main-card-layout-container-title-details">
                <h3 className="common-head goldenColor mt-3">
                  {card.card_title}
                </h3>
                <p
                  className="common-para"
                  dangerouslySetInnerHTML={{ __html: card.card_description }}
                ></p>
              </div>
            </div>
          ))}

          {/* <div className="sold-property-card col-md-6" data-aos="fade-left">
            <img src={WhyMarImag2} className="img-fluid" alt="" />

            <div className="main-card-layout-container-title-details">
              <h6 className="common-head goldenColor mt-3">
                Strong Brand Reputation & Premium Positioning
              </h6>

              <p className="common-para">
                {" "}
                <b>What it means:</b>A Marquis property is premium real estate.
              </p>

              <p className="common-para">
                {" "}
                <b>Investor Benefit: </b> This brand equity allows you to
                command superior rental income. Tenants and future buyers are
                often willing to pay more for a reputable developer known for
                quality and reliability. This directly boosts your rental yield
                and resale value.
              </p>
            </div>
          </div>

          <div className="sold-property-card col-md-6" data-aos="fade-right">
            <img src={WhyMarImag3} className="img-fluid" alt="" />

            <div className="main-card-layout-container-title-details">
              <h6 className="common-head goldenColor mt-3">
                Strategic Location Selection & Master-Planned Integration
              </h6>

              <p className="common-para">
                {" "}
                <b>What it means:</b>At Marquis, typically we don't build in
                isolated areas. We focus on emerging growth corridors or
                established areas with proven infrastructure, and often within
                larger master-planned communities.
              </p>

              <p className="common-para">
                {" "}
                <b>Investor Benefit: </b> Properties in these locations
                experience faster and more sustained capital appreciation.
                Access to transportation, schools, shopping and employment hubs
                makes the property highly desirable to a large tenant pool.
              </p>
            </div>
          </div>

          <div className="sold-property-card col-md-6" data-aos="fade-left">
            <img src={WhyMarImag4} className="img-fluid" alt="" />

            <div className="main-card-layout-container-title-details">
              <h6 className="common-head goldenColor mt-3">
                Future-Proof Design & Amenities
              </h6>
              <p className="common-para">
                {" "}
                <b>What it means:</b>Our designs incorporate modern trends like
                dedicated home office nooks, energy-efficient appliances, smart
                home readiness, and community amenities such as swimming pools,
                gyms, jogging tracks, children’s play areas, and so on.
              </p>

              <p className="common-para">
                {" "}
                <b>Investor Benefit: </b> This makes the property attractive to
                high-quality, long-term tenants (like young professionals and
                families). It also ensures the property doesn't become obsolete,
                safeguarding your investment against market shifts.
              </p>
            </div>
          </div>

          <div className="sold-property-card col-md-6" data-aos="fade-right">
            <img src={WhyMarImag5} className="img-fluid" alt="" />

            <div className="main-card-layout-container-title-details">
              <h6 className="common-head goldenColor mt-3">
                Proven Track Record
              </h6>
              <p className="common-para">
                {" "}
                <b>What it means:</b>A developer with a track record of delivery
                is more reliable, having already proven themselves by way of
                quality.
              </p>

              <p className="common-para">
                {" "}
                <b>Investor Benefit: </b> This minimizes the financial risk of
                project delays. You start earning rental income as projected,
                and your investment timeline remains on track. This reliability
                is a major risk mitigator.
              </p>
            </div>
          </div> */}
        </div>
      </Container>
    </section>
  );
}
export default WhyMarquisDescription;
